

import { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Breadcrumbs, Link } from '@mui/material';
import SpaProfile from './SpaProfile';
import SpaMenu from './SpaMenu';
import SpaBooking from './SpaBooking';
import SpaPromotion from './SpaPromotion';
import SpaAnalytics from './SpaAnalytics';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { fetchSingleSpa } from '../../api/spaApi';

export default function SpaManager({ propertyId }) {
  const { id } = useParams();
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [spaName, setSpaName] = useState('');
  const [spaData, setSpaData] = useState(null);

  const handleTabChange = (_, newValue) => {
    setTab(newValue);
  };

  useEffect(() => {
    if (!id || !propertyId) return;

    const fetchSpa = async () => {
      try {
        const data = await fetchSingleSpa(id, propertyId);
        if (data?.typeOfMassage) setSpaName(data.typeOfMassage);
        setSpaData(data);
      } catch (err) {
        console.error('Failed to fetch spa:', err);
      }
    };

    fetchSpa();
  }, [id, propertyId]);

  return (
    <Box sx={{ pt: 0, px: 3 }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        <Link
          underline="hover"
          color="inherit"
          onClick={() => {
            const backTab = searchParams.get('fromTab');
            navigate(`/hotel-info-v2${backTab ? `?tab=${backTab}` : ''}`);
          }}
          sx={{ cursor: 'pointer' }}
        >
          Back
        </Link>
        <Typography color="text.primary">{spaName || 'Spa Manager'}</Typography>
      </Breadcrumbs>

      <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
        <Tab label="Profile" />
        <Tab label="Menu" />
        <Tab label="Booking" />
        <Tab label="Promotion" />
        <Tab label="Analytics" />
      </Tabs>

      <Box mt={2}>
        {tab === 0 && <SpaProfile spaId={id} propertyId={propertyId} />}
        {tab === 1 && <SpaMenu spaId={id} propertyId={propertyId} />}
        {tab === 2 && <SpaBooking spaId={id} propertyId={propertyId} />}
        {tab === 3 && <SpaPromotion spaId={id} propertyId={propertyId} />}
        {tab === 4 && <SpaAnalytics spaId={id} propertyId={propertyId} />}
      </Box>
    </Box>
  );
}